import { env } from '@/main/config'
import { AnonEdgeHttpClient } from '@/shared/infra/http'

let cached: AnonEdgeHttpClient | null = null

export function makeAnonEdgeHttpClient(): AnonEdgeHttpClient {
  if (cached) return cached
  cached = new AnonEdgeHttpClient(env.edgeFunctionsBaseUrl, env.supabaseAnonKey)
  return cached
}
